const _ = require('lodash')

const GetImagePathList = function() {
    let result = [
        // ['wall' ,           require("@/components/pixi/assets/wall.png")],
        ['imgBgGreen',      require("@/game/assets/bg-green.png")],
        ['imgBgOrange',     require("@/game/assets/bg-orange.png")],
        ['imgBgYellow',     require("@/game/assets/bg-yellow.png")],

        ['imgP1Logo',       require("@/game/assets/p1-title/logo.png")],
        ['imgP1Title',      require("@/game/assets/p1-title/title.png")],

        ['imgP2Start',      require("@/game/assets/p2-intro/start.png")],
        ['imgP2Textbox',    require("@/game/assets/p2-intro/textbox.png")],
        ['imgP2Title',      require("@/game/assets/p2-intro/title.png")],

        ['imgP3Avatar',     require("@/game/assets/p3-playerinfo/avatar.png")],
        ['imgP3Next',       require("@/game/assets/p3-playerinfo/next.png")],

        ['imgP4Player1',    require("@/game/assets/p4-player/player1.png")],
        ['imgP4Player2',    require("@/game/assets/p4-player/player2.png")],
        ['imgP4Player3',    require("@/game/assets/p4-player/player3.png")],

        ['imgP5Kitchen',    require("@/game/assets/p5-kitchen/bg-kitchen.png")],
        ['imgP5Basket',     require("@/game/assets/p5-kitchen/basket-icon.png")],
        ['imgP5Add',        require("@/game/assets/p5-kitchen/bubble/add.png")],
        ['imgP5Close',      require("@/game/assets/p5-kitchen/bubble/x-icon.png")],
        ['imgP5SumBox',     require("@/game/assets/p5-kitchen/bubble/summarybox.png")],
        ['imgP5Trash',      require("@/game/assets/p5-kitchen/bubble/trash-icon.png")],
        ['imgP5TimeUp',     require("@/game/assets/p5-kitchen/bubble/timesup.png")],

        ['imgP6Next',       require("@/game/assets/p6-summary/next.png")],
        ['imgP6Scale',      require("@/game/assets/p6-summary/scale.png")],
        ['imgP6TextBox',    require("@/game/assets/p6-summary/textbox2.png")],

        ['imgP7PlayAgain',  require("@/game/assets/p7-result/playagain.png")],
        ['imgP7Player1',    require("@/game/assets/p7-result/player1-p7.png")],
        ['imgP7Player2',    require("@/game/assets/p7-result/player2-p7.png")],
        ['imgP7Player3',    require("@/game/assets/p7-result/player3-p7.png")],
        ['imgP7Textbox',    require("@/game/assets/p7-result/textbox3.png")],

        ['imgP7FB',    require("@/game/assets/p7-result/fb.png")],
        ['imgP7Line',    require("@/game/assets/p7-result/line.png")],
        ['imgP7Twitter',    require("@/game/assets/p7-result/twitter.png")],
    ]

    for(let i = 1; i <= 40; ++i) {
        let paddedNum = ("00" + i).substr(-2,2)
        result.push([
            'veggieIcon' + i,
            require("@/game/assets/p5-kitchen/veggie-icon/" + paddedNum + ".png")
        ])
        result.push([
            'veggieDetail' + i,
            require("@/game/assets/p5-kitchen/veggie+detail/" + paddedNum + ".png")
        ])
    }

    return result
}

export default {
    load: function(PIXI, app, callback) {        

        app.loader
            .add(
                _
                .chain(GetImagePathList())
                .map((elem) => {
                    return elem[1]
                })
                .value()
            )
            .load((loader, resources) => {
                let textureMap = {}
                
                _
                .chain(GetImagePathList())
                .forEach((elem) => {
                    textureMap[ elem[0] ] = {
                        path: elem[1],
                        texture: resources[ elem[1] ].texture,
                    }
                })
                .value()

                return callback(textureMap, resources)
            })
    },
}